import React, { ComponentProps, memo, useRef, useState, useEffect } from 'react';
import { Radio, RadioGroup } from '@chakra-ui/react';
import { Box } from '@chakra-ui/layout';
import { yo } from 'models/CommentedAnswer';

export interface IRadioField {
  val: yo;
  value: IRadioField['val'] | boolean;
}
interface IProps extends Omit<ComponentProps<typeof RadioGroup>, 'children'> {
  label?: string;
  inputRef?: React.RefObject<IRadioField>;
  tooltip?: string;
  onChange?: (e: IRadioField['val']) => void;
  isBool?: boolean;
  defaultValue?: IRadioField['value'];
  value?: IRadioField['val'];
}

const RadioFieldComp: React.FC<IProps> = ({
  inputRef,
  onChange,
  isBool,
  value: eValue,
  defaultValue,
  ...props
}) => {
  const [value, setValue] = useState<IRadioField['val']>('no');

  const radioRef = useRef<IRadioField>({
    val: value,
    get value() {
      return this.val ? (isBool ? this.val === 'yes' : this.val) : this.val;
    },
    set value(value: IRadioField['value']) {
      this.val = typeof value === 'boolean' ? (value ? 'yes' : 'no') : value;
      setValue(this.val);
    },
  });

  useEffect(() => {
    // @ts-ignore
    if (inputRef) inputRef.current = radioRef.current;
    if (defaultValue !== undefined) radioRef.current.value = defaultValue;
    if (eValue !== undefined) radioRef.current.value = eValue;
  }, []);

  return (
    <Box>
      <RadioGroup
        display="flex"
        alignItems="center"
        gridGap="20px"
        onChange={(v: yo) => {
          radioRef.current.value = v;
          if (onChange) onChange(v);
        }}
        value={value}
        {...props}
      >
        <Box
          color={value === 'yes' ? 'brand.tertiary' : undefined}
          fontWeight={value === 'yes' ? '700' : undefined}
          fontSize="16px"
          display="flex"
          alignItems="center"
        >
          <Radio
            outline="0"
            _focus={{
              outline: 0,
            }}
            _checked={{
              position: 'relative',
              backgroundColor: 'brand.1300',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderColor: 'brand.tertiary',
              '&:after': {
                position: 'absolute',
                content: "''",
                backgroundColor: 'brand.tertiary',
                width: '65%',
                height: '65%',
                borderRadius: '50%',
                transform: 'translate(-50%, -50%)',
                top: '52%',
                left: '50%',
              },
            }}
            value="yes"
            mr="8px"
            isDisabled={props.disabled}
          >
            Sim
          </Radio>
        </Box>
        <Box
          color={value === 'no' ? 'brand.tertiary' : undefined}
          fontWeight={value === 'no' ? '700' : undefined}
          fontSize="16px"
          display="flex"
          alignItems="center"
        >
          <Radio
            outline="0"
            _focus={{
              outline: 0,
            }}
            _checked={{
              position: 'relative',
              backgroundColor: 'brand.1300',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderColor: 'brand.tertiary',
              '&:after': {
                position: 'absolute',
                content: "''",
                backgroundColor: 'brand.tertiary',
                width: '65%',
                height: '65%',
                borderRadius: '50%',
                transform: 'translate(-50%, -50%)',
                top: '50%',
                left: '50%',
                zIndex: 2,
              },
            }}
            value="no"
            mr="8px"
            isDisabled={props.disabled}
          >
            Não
          </Radio>
        </Box>
      </RadioGroup>
    </Box>
  );
};

export const RadioField = memo(RadioFieldComp);
